<template>
  <div>
    <div class="clear-both"></div>
    <div  v-if="hint" class="hint-text" >
      {{combinedMessage}}
    </div>
    <div class="clear-both"></div>
  </div>
</template>

<script>
import * as validate from '../js/validation.js'

export default {
  data: () => ({
    hasInvalidChar: true,
    denyListCounter: 0,
    hint: false,
    combinedMessage: ''
  }),
  props: {
    password: {
      type: String
    },
    firstName: {
      type: String
    },
    lastName: {
      type: String
    },
    userName: {
      type: String
    }
  },
  mounted: function () {
    this.onPasswordChange()
  },
  watch: {
    password: {
      handler () {
        this.onPasswordChange()
      }
    }
  },
  methods: {
    onPasswordChange: function () {
      this.DenyListCheck(this.password)
    },

    DenyListCheck: function (password) {
      this.denyListCounter = 0
      this.hint = false
      this.combinedMessage = ''
      if (validate.hasName(password, this.firstName)) {
        if (this.denyListCounter === 0) {
          this.combinedMessage += this.$t('components.password.denyList.sentence')
        }
        this.combinedMessage += this.denyListCounter > 0 ? ', ' + this.$t('components.password.denyList.denyFirstname') : this.$t('components.password.denyList.denyFirstname')
        this.denyListCounter++
        this.hint = true
      }
      if (validate.hasName(password, this.lastName)) {
        if (this.denyListCounter === 0) {
          this.combinedMessage += this.$t('components.password.denyList.sentence')
        }
        this.combinedMessage += this.denyListCounter > 0 ? ', ' + this.$t('components.password.denyList.denyLastname') : this.$t('components.password.denyList.denyLastname')
        this.denyListCounter++
        this.hint = true
      }
      if (validate.hasName(password, this.userName)) {
        if (this.denyListCounter === 0) {
          this.combinedMessage += this.$t('components.password.denyList.sentence')
        }
        if (this.$store.state.isMobileLoginDisabled) {
          this.combinedMessage += this.denyListCounter > 0 ? ', ' + this.$t('components.password.denyList.denyEmail') : this.$t('components.password.denyList.denyEmail')
        } else {
          this.combinedMessage += this.denyListCounter > 0 ? ', ' + this.$t('components.password.denyList.denyUsername') : this.$t('components.password.denyList.denyUsername')
        }
        this.denyListCounter++
        this.hint = true
      }
      if (validate.repetitiveAndSequenceCheck(password)) {
        if (this.denyListCounter === 0) {
          this.combinedMessage += this.$t('components.password.denyList.sentence')
        }
        this.combinedMessage += this.denyListCounter > 0 ? ', ' + this.$t('components.password.denyList.denySequentialChar') : this.$t('components.password.denyList.denySequentialChar')
        this.denyListCounter++
        this.hint = true
      }
      if (this.combinedMessage.length > 0) {
        this.combinedMessage += '.'
      }
    }
  }
}
</script>

<style scoped>

    .hint-text {
      font-size: 13px;
      color: gray;
      text-align: left;
    }

    .clear-both {
      clear: both;
    }
</style>
